<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Expense Reports Dashboard</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">

                <b-form-group v-if="isAdmin == true" style="text-align:center;">
                    <b-form-radio-group v-model="showAdminDashboard" buttons size="sm"
                                        :options="[{ text: 'Admin Dashboard', value:true },{ text: 'User Dashboard', value:false }]"></b-form-radio-group>
                </b-form-group>           

                <div class="row">
                    <div class="col-md-3">

                    </div>
                    <div v-if="showAdminDashboard == false" class="col-md-6">
                        <a class="btn btn-success d-flex justify-content-center mt-1 btn-lg" style="font-weight:bold; color:white;" @click="$router.push('travel-expense-report')" href="#">Create New Travel Expense Report</a>
                        <a v-if="showAdminDashboard == false" class="btn btn-success d-flex justify-content-center mt-1 mb-4 btn-lg" style="font-weight:bold; color:white;" @click="$router.push('misc-expense-report')" href="#">Create New Misc Expense Report</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('projectusers/edit')">Your Projects</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('reports-in-progress/false')">Reports in Progress</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('receipt-bucket')">Receipts</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('institutional-documents')">Institutional Documents</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('pi-approval')" href="#">Pending Your Approval</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('submitted-paid-reports')" href="#">Submitted / Paid Reports</a>
                        <a class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('pi-analysis')">Analysis</a>
                    </div>
                    <div class="col-md-6">

                        <!-- Admin -->
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('projects')">Manage Projects</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('projectusers')">Manage Project Users</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('institutional-documents')">Manage Institutional Documents</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('reports-in-progress/true')">Reports in Progress</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('admin-approval')">Admin 1 Approvals</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('admin2-approval')">Admin 2 Approvals</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('pending-payments')">Pending Payments</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('admin-analysis')">Analysis</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('admin-gl-report')">GL Report</a>
                        <a v-if="isAdmin && showAdminDashboard" class="btn btn-primary d-flex justify-content-center my-1" @click="$router.push('import-per-diem')">Import Foreign/Other US Per Diem</a>
                    </div>
                        <div class="col-md-3">

                        </div>
                        
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
    import UserService from '@/services/UserService';
    import { msalMixin } from 'vue-msal'; 

    export default {
        mixins: [msalMixin],
        data: function () {
            return {
                showAdminDashboard: false,
                isAdmin: false
            }
        }, 
        watch: {
            'msal.accessToken': {
                async handler(value) {
                    console.log('getting user roles')
                    this.isAdmin = await UserService.isUserAdmin();
                },
                immediate: true
            }
        },
        created() {
            this.setDefaultDashboardChoice();
        },
        methods: {
            setDefaultDashboardChoice() {
                return this.showAdminDashboard = this.isAdmin;
            }
        }
    }
</script>